export const NEXT_PUBLIC_THRIVENT_BASE_URL: string = process.env[
  'NEXT_PUBLIC_THRIVENT_BASE_URL'
] as string;

export const NEXT_PUBLIC_THRIVENT_HEADER_BASE_URL: string = process.env[
  'NEXT_PUBLIC_THRIVENT_HEADER_BASE_URL'
] as string;
